// @flow

export const TimeRange = {
  min: 4,
  max: 28,
}

export const TaskPlaces = {
  TIMETABLE: 'TimeTable',
  STOCK: 'Stock',
}

export const Colors = [
  ['white', '#fafafa'],
  ['orange', '#ffd180'],
  ['blue', '#80d8ff'],
  ['green', '#ccff90'],
]

export const TimeLengths = [30, 60, 90, 120]

export const TutorialPlan = {
  title: 'Tutorial',
  start: 8,
  end: 23,
  tasks: [
    {
      id: 'WFP1j9W',
      body: 'Day Planへようこそ！',
      color: '#80d8ff',
      length: 30,
    },
    {
      id: 'U3HMGUu',
      body: '使い方を説明します！',
      color: '#fafafa',
      length: 60,
    },
    null,
    { id: 'Zz3xfJR', body: '1. 予定の作成', color: '#ffd180', length: 30 },
    {
      id: 'RbrllCX',
      body: '薄い+の部分をタップorクリック！',
      color: '#fafafa',
      length: 30,
    },
    {
      id: 'r5RN9D8',
      body: '内容・時間・色を入力！',
      color: '#fafafa',
      length: 30,
    },
    null,
    { id: 'zWX~Uiu', body: '2. 予定の編集', color: '#ffd180', length: 30 },
    {
      id: 'lIrl_6s',
      body: '既存の予定をタップorクリック！',
      color: '#fafafa',
      length: 30,
    },
    {
      id: 'EovR75j',
      body: '削除は右のゴミ箱ボタンから！',
      color: '#fafafa',
      length: 30,
    },
    {
      id: '5koJdGo',
      body: 'ドラッグ&ドロップで移動！',
      color: '#fafafa',
      length: 30,
    },
    null,
    { id: 'YilFawo', body: '4. 設定の変更', color: '#ffd180', length: 30 },
    {
      id: 'pA~0pgT',
      body: '右上の歯車をタップorクリック！',
      color: '#fafafa',
      length: 30,
    },
    {
      id: 'r8on2tS',
      body: 'タイトルと開始・終了時間を変更！',
      color: '#fafafa',
      length: 30,
    },
    null,
    {
      id: '6UMQ4EA',
      body: '5. できたらシェア！',
      color: '#ffd180',
      length: 30,
    },
    {
      id: 'YmW1Kjk',
      body: 'これも右上のボタンから！',
      color: '#fafafa',
      length: 30,
    },
    null,
    { id: 'M_~rJB4', body: 'これで以上！', color: '#80d8ff', length: 30 },
    { id: 't9mqr~K', body: '左上のメニューから', color: '#fafafa', length: 30 },
    {
      id: 'Iwjeekn',
      body: 'New Planを選択して始めよう！',
      color: '#fafafa',
      length: 30,
    },
    null,
    { id: 'xfxVUW9', body: 'それでは、、', color: '#fafafa', length: 30 },
    {
      id: '_MIk_Sk',
      body: '素敵なDay Planライフを！',
      color: '#ccff90',
      length: 60,
    },
    null,
    null,
    null,
  ],
}



// WEBPACK FOOTER //
// ./src/constants/index.js